import React from 'react';
import { Text } from '@react-pdf/renderer';

const PDFText: React.FC = ({ children }) => {
  return <Text style={{ fontSize: 14, textAlign: 'left', lineHeight: 1.5 }}>{children}</Text>;
};

export default PDFText;
